import baner from '../../assets/images/baner.jpg'

const BlueBaner = ({title,text}) => {
    return(
        <div className='relative min-h-[220px] rounded-[20px] mt-2 
        lg:mt-0'>
            <img
            src={baner}
            className='object-cover h-full rounded-[20px]'
            />
            <span
            className='bg-gradient-to-r from-[#49D1CD] via-[#4DB9B1] 
            to-[#49D1CD] opacity-90 rounded-[20px] absolute w-full h-full
            top-0'
            ></span>
            <div className='absolute inset-0 flex flex-col items-center
            justify-center text-white p-5'>
                <h3 className='font-bold text-[20px] lg:text-[25px]'>
                    {title}
               </h3>
                <p className='text-center'>
                    {text}
                </p>
            </div>
        </div>
    )
    }
export default BlueBaner